'use client';
import React from 'react';

const BASE = 'https://cullertons-b4f8396.public.builtwithrocket.new';

export default function Footer() {
  return (
    <footer className="border-t border-forest/10 py-10 px-6 md:px-12 bg-cream">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + Name */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <img
              alt="Logo"
              width={48}
              height={48}
              className="flex-shrink-0"
              src="/assets/images/Logo_C_only-1776860909441.png" />

          </div>
          <div>
            <span className="font-serif text-lg block leading-tight text-[rgba(156,155,150,1)]">Cullerton&apos;s</span>
            <span className="text-[10px] text-forest/50 uppercase tracking-widest">NEW TOWN · EH3</span>
          </div>
        </div>

        {/* Nav links */}
        <div className="flex items-center gap-8 text-[13px] font-medium text-forest/55">
          <a href="#locality" className="hover:text-forest transition-colors">New Town</a>
          <a href="#about" className="hover:text-forest transition-colors">About</a>
          <a href="#approach" className="hover:text-forest transition-colors">Services</a>
          <a href="#valuation" className="hover:text-forest transition-colors">Valuation</a>
        </div>

        {/* Legal */}
        <div className="flex items-center gap-6 text-[12px] text-forest/40">
          <span>© 2026 Cullerton&apos;s Estate Agents Ltd</span>
          <a className="hover:text-forest/70 transition-colors" href="#">Privacy</a>
          <a className="hover:text-forest/70 transition-colors" href="#">Terms</a>
        </div>
      </div>
    </footer>);

}